export default __webpack_public_path__ + "static/media/home_tab_icon.e5af7444.svg";